// subscribeStreamViewerChannel.js
'use strict';
import getMeData from '../selector/getMeData.js';
import * as MessageTypes from '../serviceWorker/AppMessageTypes.js';
import { sendMessageToSW } from '../serviceWorker/helpers.js';
import { PRESET_SD } from '../resource/liveStreamConstants.js';
import getCurrentUnixTimestamp from '../resource/getCurrentUnixTimestamp.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';
import getOperationData from '../selector/getOperationData.js';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Subscribe stream viewer channel
 * @kind action
 * @param {string} {streamId} - stream id.
 * @param {string} {preset} - stream preset.
 * @return {Promise} Action promise.
 */
const subscribeStreamViewerChannel =
  ({ streamId, preset = PRESET_SD, nbf = 0 }) =>
  async (dispatch, getState) => {
    const userId = getMeData(getState(), 'id');
    if (!streamId || !userId) {
      return dispatch({ type: '' });
    }
    const timestampOffsetSeconds =
      getTimestampOffset(getState(), Accuracy.SECOND) || 0;
    const now = getCurrentUnixTimestamp({
      offsetSeconds: timestampOffsetSeconds,
    });

    if (now < nbf) {
      const existedTimerId = getOperationData(
        getState(),
        ['timer', 'livestream', streamId, preset],
        'delaySubscribe'
      );
      if (existedTimerId) {
        clearTimeout(existedTimerId);
        dispatch({
          type: MERGE_OPERATION_DATA,
          payload: {
            selectPath: ['timer', 'livestream', streamId, preset],
            data: {
              delaySubscribe: null,
            },
          },
        });
      }
      const timerId = setTimeout(
        () => {
          dispatch({
            type: MERGE_OPERATION_DATA,
            payload: {
              selectPath: ['timer', 'livestream', streamId, preset],
              data: {
                delaySubscribe: null,
              },
            },
          });
          sendMessageToSW({
            type: MessageTypes.SUBSCRIBE_STREAM_VIEWER_CHANNEL,
            payload: {
              streamId,
              preset,
              userId,
            },
          });
        },
        (nbf - now) * 1000
      );
      return dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['timer', 'livestream', streamId, preset],
          data: {
            delaySubscribe: timerId,
          },
        },
      });
    } else {
      return sendMessageToSW({
        type: MessageTypes.SUBSCRIBE_STREAM_VIEWER_CHANNEL,
        payload: {
          streamId,
          preset,
          userId,
        },
      });
    }
  };

export default subscribeStreamViewerChannel;
